import React from 'react';

// Styles & Assets
import styles from './FilterUsersDialog.module.css';
import { ReactComponent as FilterSVG } from '../../../assets/icons/filter-off-fill.svg';

// Hooks
import { useState } from 'react';

// Components
import RowButtonsFilter from '../../PatientsPage/RowButtonsFilter/RowButtonsFilter';

// Interfaces
import { FiltersUsers } from '../../../interfaces/Filters';
import { UsersFiltersDispatch } from '../../../interfaces/UserInfo';

// Language
import { useTranslation } from 'react-i18next';

const FilterUsersDialog: React.FC<{
    filtersUsers: FiltersUsers,
    dispatchUsersFilters: React.Dispatch<UsersFiltersDispatch>
    modalShow: React.Dispatch<React.SetStateAction<boolean>>
    setFilterBallActive: (isActive: boolean) => void
}> = ({ filtersUsers, dispatchUsersFilters, modalShow, setFilterBallActive }) => {

    const [filtersActiveUser, setFiltersActiveUser] = useState<number[]>(filtersUsers.currentFiltersActive);
    const [filtersRole, setFiltersRole] = useState<number[]>(filtersUsers.currentFiltersRole);

    const { t } = useTranslation();

    const deleteFilters = () => {
        dispatchUsersFilters({type: 'DELETE_FILTERS'});
        setFilterBallActive(false);
        setFiltersActiveUser([]);
        setFiltersRole([]);
    };

    const applyFilters = () => {
        dispatchUsersFilters({type: 'ACTIVE', currentFilters: filtersActiveUser});
        dispatchUsersFilters({type: 'ROLE', currentFilters: filtersRole});

        setFilterBallActive( 
            filtersActiveUser.some(filter => filter) ||
            filtersRole.some(filter => filter)
        );
        modalShow(false);
    };

    const activeFiltersContent = [{ id: 0, content: t('yes') }, { id: 1, content: t('no') }];
    const roleFiltersContent = [{ id: 2, content: t('doctor') }, { id: 1, content: t('nurse') }];

    return (
        <div className='dialog'>
            <div className={styles.dialogContent}>
                <div className={styles.topContainer}>
                    <div>
                        <h1 className='dialogTitle'>{t('filter')}</h1>
                        <h2 className='dialogSubTitle'>{t('users_list')}</h2>
                    </div>
                    <button onClick={deleteFilters} className='buttonRemoveFilter'>
                        {t('remove_filters')} <FilterSVG  />
                        </button>
                </div>
                <div>
                    <RowButtonsFilter
                        text={t('active_user')}
                        currentFilters={filtersActiveUser}
                        setFilters={setFiltersActiveUser}
                        content={activeFiltersContent}
                    />
                    <RowButtonsFilter
                        text={t('role')}
                        currentFilters={filtersRole}
                        setFilters={setFiltersRole}
                        content={roleFiltersContent}
                    />
                </div>
            </div>
            <div className={styles.buttonWrapper}>
                <button onClick={applyFilters} className={`${styles.button} button`}>{t('filter')}</button>
            </div>
        </div>
    );
};

export default FilterUsersDialog;
